import {jwtDecode} from 'jwt-decode'

import HeadComponent from "../../components/HeadComponent";
import PanelSearchComponent from "../../components/PanelSearchComponent";

import "./DashboardPage.css";

function DashboardPage() {

  document.body.classList.add("background-white");

  const token = localStorage.getItem("authTokens")

  if (token) {
    const decode = jwtDecode(token);
  }

  return (
    <div>
      <HeadComponent/>
      <PanelSearchComponent/>
    </div>
  );
}

export default DashboardPage;
